export const CREATE = 'CREATE' // 缓存开始创建
export const CREATED = 'CREATED' // 缓存创建成功
export const ACTIVE = 'ACTIVE' // 缓存被激活
export const DESTROY = 'DESTROY' // 销毁
export const RESET = 'RESET' // 重置
export const CLEAR = 'CLEAR' // 重置所有